var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary custom-flex pa-3"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }